export {SpecialOffer as default} from './specialOffer';
